import { useLocation, Link } from "react-router-dom"
import AccountMenuComponent from "../../../lib/bandung/components/AccountMenu/AccountMenuComponent";
import { getSession } from "../../../lib/bandung/bandung";

export default function Header() {
  const location = useLocation()
  const isLandingPage = location.pathname === "/"

  const categoriesItems = {
    "/conversation": "Conversation list",
    "/conversation/create": "Create a conversation",
  }

  const companiesItems = {
    "/companyName": "Company page",
    "/searchResults": "Search companies",
  }

  const isValidSession = getSession();

  return (
      <header className="bg-white border-b border-gray-200">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between py-4">
            <div className="w-32"></div>

            <a href="/" className="flex-shrink-0">
              <img
                width="160"
                src="/assets/images/MarketFusionLogo.png"
                alt="MarketFusion"
                onError={(e) => {
                  e.target.style.display = "none"
                  e.target.parentElement.innerHTML =
                    '<span class="text-2xl font-bold text-blue-600">MarketFusion</span>'
                }}
              />
            </a>

            {/* <div className="flex items-center gap-4 w-32 justify-end">
              <button type="button" className="text-gray-600 hover:text-gray-900" aria-label="Search">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="11" cy="11" r="8"></circle>
                  <path d="m21 21-4.35-4.35"></path>
                </svg>
              </button>
              <a
                href="/signin"
                className="px-5 py-2 bg-[#8B1538] text-white rounded-md hover:bg-[#6B1028] font-medium text-sm whitespace-nowrap"
              >
                Register / Sign In
              </a>
            </div> */}

            <AccountMenuComponent />

            
          </div>

          <nav className="border-t border-gray-200">
            <ul className="flex items-center justify-center gap-8 py-3">
              <li>
                <a href="/" className="text-base font-medium text-gray-900 hover:text-gray-600">
                  Home
                </a>
              </li>
              <li>
                <a href="/about" className="text-base font-medium text-gray-900 hover:text-gray-600">
                  About
                </a>
              </li>
              <li>
                <a href="/category" className="text-base font-medium text-gray-900 hover:text-gray-600">
                  Categories
                </a>
              </li>
              {/* <li className="relative group">
                <button className="text-base font-medium text-gray-900 hover:text-gray-600 flex items-center gap-1">
                  Categories
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    className="transition-transform duration-150 group-hover:rotate-180"
                  >
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </button>

                <div className="absolute left-1/2 -translate-x-1/2 top-full mt-1 invisible opacity-0 translate-y-1 pointer-events-none group-hover:visible group-hover:opacity-100 group-hover:translate-y-0 group-hover:pointer-events-auto transition-all duration-150 z-50">
                  <div className="min-w-[240px] rounded-xl border border-gray-200 bg-white shadow-lg">
                    <ul className="py-2">
                      {Object.entries(categoriesItems).map(([href, label]) => (
                        <li key={href}>
                          <a
                            href={href}
                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-rose-50 hover:text-gray-900"
                          >
                            {label}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </li> */}
            
              <li className="relative group">
                <button className="text-base font-medium text-gray-900 hover:text-gray-600 flex items-center gap-1">
                  Companies
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    className="transition-transform duration-150 group-hover:rotate-180"
                  >
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </button>

                <div className="absolute left-1/2 -translate-x-1/2 top-full mt-1 invisible opacity-0 translate-y-1 pointer-events-none group-hover:visible group-hover:opacity-100 group-hover:translate-y-0 group-hover:pointer-events-auto transition-all duration-150 z-50">
                  <div className="min-w-[240px] rounded-xl border border-gray-200 bg-white shadow-lg">
                    <ul className="py-2">
                      {Object.entries(companiesItems).map(([href, label]) => (
                        <li key={href}>
                          <a
                            href={href}
                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-rose-50 hover:text-gray-900"
                          >
                            {label}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </li>
             
              {/* <li>
                <a href="/contact" className="text-base font-medium text-gray-900 hover:text-gray-600">
                  Contact
                </a>
              </li> */}

              {/* Only show Supplier Hub on valid login */}
              {isValidSession ? 

                <li>
                  <Link
                    to="/supplierDashboard"
                    className="items-center rounded-xl bg-rose-600 px-6 py-2.5 text-white shadow hover:bg-rose-700 transition duration-200"
                  >
                    Supplier Hub
                  </Link>
                </li>
                
              : ""}
                
              
            </ul>
          </nav>
        </div>
      </header>
    )
  }

